import { defineStore } from 'pinia'
import { Environment } from '@/enums'

interface EnvironmentState {
  currentEnv: Environment
}

export const useEnvironmentStore = defineStore({
  id: 'environment',
  state: (): EnvironmentState => ({
    currentEnv: Environment.Production,
  }),
  getters: {
    getCurrentEnv: (state): Environment => state.currentEnv,
    isDevelopment: (state): boolean => state.currentEnv === Environment.Development,
    isProduction: (state): boolean => state.currentEnv === Environment.Production,
    isAzureUAT: (state): boolean => state.currentEnv === Environment.AzureUAT,
    isAzureProd: (state): boolean => state.currentEnv === Environment.AzureProd,
  },
  actions: {
    setEnvironment() {
      const env = import.meta.env.MODE as string
      switch (env) {
        case 'development':
          this.currentEnv = Environment.Development
          break
        case 'azure-uat':
          this.currentEnv = Environment.AzureUAT
          break
        case 'azure-prod':
          this.currentEnv = Environment.AzureProd
          break
        default:
          this.currentEnv = Environment.Production
      }
    },
  },
  persist: true,
})
